export default "__VITE_ASSET__C5p0tK3s__"